import { COMPONENT_SIZES as e, TEXT_HEADLINE_SIZES as t } from "./sizes.js";
import { LAYOUT_PERCENT_VALUES as n, LAYOUT_SIZE_VALUES as r, LAYOUT_VALUES as i } from "./layout.js";
//#region common/constants/index.js
var a = typeof HTMLElement < "u" ? HTMLElement : Object, o = {
	CRITICAL: "critical",
	WARNING: "warning",
	POSITIVE: "positive",
	INFO: "info"
}, s = {
	LARGE: "lg",
	EXTRA_LARGE: "xl"
}, c = {
	100: "d-description--xs",
	200: "d-description--sm",
	300: "",
	400: "d-description--lg",
	500: "d-description--xl",
	xs: "d-description--xs",
	sm: "d-description--sm",
	md: "",
	lg: "d-description--lg",
	xl: "d-description--xl"
}, l = {
	100: "d-label--xs",
	200: "d-label--sm",
	300: "",
	400: "d-label--lg",
	500: "d-label--xl",
	xs: "d-label--xs",
	sm: "d-label--sm",
	md: "",
	lg: "d-label--lg",
	xl: "d-label--xl"
}, u = {
	esc: "Esc",
	escape: "Escape",
	tab: "Tab",
	enter: "Enter",
	space: "Space",
	spacebar: "Spacebar",
	up: "Up",
	arrowup: "ArrowUp",
	left: "Left",
	arrowleft: "ArrowLeft",
	right: "Right",
	arrowright: "ArrowRight",
	down: "Down",
	arrowdown: "ArrowDown",
	home: "Home",
	end: "End"
}, d = o.CRITICAL, f = "dt", p = {
	VALIDATION_MESSAGE_TYPES: o,
	DESCRIPTION_SIZE_TYPES: s,
	DEFAULT_VALIDATION_MESSAGE_TYPE: d,
	DEFAULT_PREFIX: "dt"
};
//#endregion
export { e as COMPONENT_SIZES, f as DEFAULT_PREFIX, d as DEFAULT_VALIDATION_MESSAGE_TYPE, c as DESCRIPTION_SIZE_MODIFIERS, s as DESCRIPTION_SIZE_TYPES, u as EVENT_KEYNAMES, a as HTML_ELEMENT_TYPE, l as LABEL_SIZE_MODIFIERS, n as LAYOUT_PERCENT_VALUES, r as LAYOUT_SIZE_VALUES, i as LAYOUT_VALUES, t as TEXT_HEADLINE_SIZES, o as VALIDATION_MESSAGE_TYPES, p as default };

//# sourceMappingURL=index.js.map